import React from "react";
import flexibleRepaymentInfo from "../assets/img/flexible_repayment_info.png";

function HeroBanner() {
  return (
    <>
      <section>
        <div className="banner-hero">
          <div className="container">
            <div className="col-lg-12">
              <div className="row justify-content-between align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-6">
                  <div className="hero-text-main">
                    <span className="small-heading">Flexicash</span>
                    <h1 className="hero-heading">
                      Avail <span className="highlight-text">instant cash</span>{" "}
                      and repay on the go!
                    </h1>
                    <p className="hero-desc">
                      Activate FlexiCash and avail up to Rs. 25 lacs cash with
                      flexible repayment options
                    </p>
                  </div>
                  <div className="button-container">
                    <a href={process.env.REACT_APP_LOGIN_URL} className="com-btn">
                      Get Started
                    </a>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 text-lg-end text-sm-center flexible-repayment-size">
                  <img
                    src={flexibleRepaymentInfo}
                    alt="Flexible Repayments"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HeroBanner;
